export enum EnumUserCurrentTab {
	Details = "details",
	Chat = "chat",
	Quote = "my_quote",
	TransactionDetails = "transaction_details",
}

export enum DeviceTypeEnum {
	Web = 1,
	Mobile = 2,
}

export enum NotificationPermissionEnum {
	Default = "default",
	Denied = "denied",
	Granted = "granted",
}

export enum GridIdsEnum {
	EventAiDirectRequests = "EVENT_AI_DIRECT_REQUEST",
	EventDirectRequests = "EVENT_DIRECT_REQUEST",
	EventInProgress = "EVENT_IN_PROGRESS",
	EventApproved = "EVENT_APPROVED",
	EventCompleted = "EVENT_COMPLETED",
	EventDeclined = "EVENT_DECLINED",
	REFUND_EVENTS = "REFUND_EVENTS",
	EVENT_ACTIVE = "EVENT_ACTIVE",
	PENDING_EVENTS = "PENDING_EVENTS",
	ADMIN_DASHBOARD = "ADMIN_DASHBOARD",
	CORPORATE_EVENTS_ACTIVE = "CORPORATE_EVENTS_ACTIVE",
	CORPORATE_EVENTS_APPROVED = "CORPORATE_EVENTS_APPROVED",
	CORPORATE_EVENTS_DECLINED = "CORPORATE_EVENTS_DECLINED",
	CORPORATE_EVENTS_COMPLETED = "CORPORATE_EVENTS_COMPLETED",
}

export enum GridTypesEnum {
	AiDirectRequest = "AI_DIRECT_REQUEST",
	Event = "EVENT",
	CORPORATE_EVENTS = "CORPORATE_EVENTS",
}

/* --------------------------------- B2B --------------------------------- */

export enum CorporateEventStatusEnum {
	InActive = 0,
	Active = 1,
	Accepted = 2,
	Completed = 3,
	Cancelled = 4,
}

export enum CorporateEventPaymentStatusEnum {
	UnPaid = 0,
	Paid = 1,
}

export enum CorporateEventVendorStatusEnum {
	AvailableForBidding = 0,
	Bidding = 1,
	Accepted = 2,
	Rejected = 3,
	Cancelled = 4,
	Completed = 5,
}

export enum RespondToCorporateEventInviteEnum {
	Decline = 2,
}

export enum CorporateEventBidStatusEnum {
	Pending = 0,
	Accepted = 1,
	Rejected = 2,
}

export enum CorporateEventTabsEnum {
	Messaging = "messaging",
	Event = "event",
	Quotes = "quotes",
}

export enum PdfCompressionQualityEnum {
	SCREEN = "screen", // Low quality, small file size (72 dpi)
	EBOOK = "ebook", // Medium quality, moderate file size (150 dpi)
	PRINTER = "printer", // High quality, larger file size (300 dpi)
	PREPRESS = "prepress", // Highest quality, largest file size (300 dpi, color preserved)
}

export enum SectionTypeEnum {
	MENU = "menu",
	SERVICE = "service",
}

export enum AiMenuExtractionStatusEnum {
	Success = "success",
	RateLimited = "rate_limited",
	Processing = "processing",
	Failed = "failed",
}

export enum CorporateEventBidPaymentStatusEnum {
	Pending = 0,
	Paid = 1,
	Failed = 2,
}

export enum VendorPhotoLibraryTypesEnum {
	Uncategorized = 0,
	All = 1,
  VendorProfileImages = 2,
}

export enum DefaultVendorPhotoLibrarySectionIdsEnum {
	AllPhotos = "allPhotos",
	Uncategorized = "uncategorized",
	VendorProfileImages = "vendorProfileImages",
}

export enum DefaultVendorPhotoLibrarySectionNamesEnum {
	AllPhotos = "All Photos",
	Uncategorized = "Uncategorized",
	VendorProfileImages = "Vendor Profile Images",
}

export enum DateFilterEnum {
	ALL_TIME = "allTime",
	LAST_30_DAYS = "last30days",
	LAST_3_MONTHS = "last3months",
	LAST_6_MONTHS = "last6months",
	LAST_YEAR = "lastYear",
	CUSTOM = "custom",
}

export enum EventTypeEnum {
	CUSTOM_EVENT = "CUSTOM_EVENT",
	CORPORATE_EVENT = "CORPORATE_EVENT",
}

export enum EventSourceEnum {
  WebDesktop = 'web / desktop',
  WebMobile = 'web / mobile',
  MobileIos = 'mobile app / ios',
  MobileAndorid = 'mobile app / android',
  shopify = 'shopify',
}

export enum ChatFilterTypeEnum {
  All = 'all',
  Unread = 'unread',
}

export enum EventTypeFilterEnum {
  B2C = 'B2C',
  B2B = 'B2B',
  Prepaid = 'Prepaid',
}
